import { useEffect, useState } from "react";
import { Footer } from "../components/Footer";
import { Navbar } from "../components/Navbar";

const AboutUs = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      {/* Hero Section */}
      <main className="flex-1 container mx-auto px-4 pt-32 pb-24">
        <div
          className={`text-center transition-all duration-1000 transform ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <div className="inline-flex items-center justify-center w-24 h-24 bg-green-100 rounded-full mb-6">
            <img src="/igbanwo-icon.png" alt="icon" className="w-16" />
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            About <span className="text-igbanwo-mint">Igbanwo</span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Rethinking how we share homegrown abundance within our communities.
          </p>
        </div>

        {/* Our Story */}
        <div
          className={`mt-16 w-full transition-all duration-1000 transform ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <h2 className="text-3xl font-bold mb-12 text-center">Our Story</h2>

          <div className="grid gap-8 md:grid-cols-3 items-start">
            {/* Card 1 */}
            <div className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-2xl border border-border/40 shadow-md hover:shadow-xl transition-all hover:-translate-y-2 flex flex-col text-center h-full">
              {/* Number circle */}
              <div className="w-12 h-12 bg-igbanwo-mint/20 text-igbanwo-mint rounded-full flex items-center justify-center mx-auto mb-6 font-bold">
                1
              </div>
              {/* Paragraph */}
              <p className="text-lg text-gray-700 leading-relaxed">
                <span className="font-semibold text-gray-900">Igbanwo</span> is
                a project of the <em>Imaginarium</em>, a collective of curious
                minds trying to solve common and overlooked problems.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-2xl border border-border/40 shadow-md hover:shadow-xl transition-all hover:-translate-y-2 flex flex-col text-center h-full">
              <div className="w-12 h-12 bg-igbanwo-mint/20 text-igbanwo-mint rounded-full flex items-center justify-center mx-auto mb-6 font-bold">
                2
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                <span className="font-semibold text-gray-900">Rethinking</span>{" "}
                how lowering the friction of information can lower waste,
                improve quality, and create food security in communities.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-2xl border border-border/40 shadow-md hover:shadow-xl transition-all hover:-translate-y-2 flex flex-col text-center h-full">
              <div className="w-12 h-12 bg-igbanwo-mint/20 text-igbanwo-mint rounded-full flex items-center justify-center mx-auto mb-6 font-bold">
                3
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                <span className="font-semibold text-gray-900">Born</span> from
                the simple problem of too many tomatoes in one garden with no
                clear way to share them – Igbanwo is a platform for bartering
                homegrown abundance: from herbs and eggs to compost and
                seedlings.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AboutUs;
